"use client";

import classNames from "classnames";
import { forwardRef } from "react";

import { Typography } from "../typography";

import styles from "./button.module.scss";
import { ButtonProps } from "./button.types";

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      size = "small",
      variant = "primary",
      selected = false,
      disabled = false,
      fullWidth = false,
      icon: Icon,
      children,
      className,
      ...restProps
    },
    ref
  ) => {
    if (disabled && selected) {
      throw new Error('Button with props selected and disabled === "true" concurrently cant be exist!');
    }

    return (
      <button
        {...restProps}
        ref={ref}
        disabled={disabled}
        className={classNames(
          styles.button,
          styles[`size--${size}`],
          styles[`variant--${variant}`],
          !children && styles.iconOnly,
          selected && styles.selected,
          disabled && styles.disabled,
          fullWidth && styles.fullWidth,
          className
        )}
      >
        {Icon && <Icon className={styles.icon} />}

        {children && (
          <Typography variant="subheadline" className={styles.typo}>
            {children}
          </Typography>
        )}
      </button>
    );
  }
);

Button.displayName = "Button";

export { Button };
